/**
 * Kraken Exchange Metadata
 */

import { KRAKEN_WS_CHANNELS, KRAKEN_WS_TOPOLOGY } from './ws';

import type { ExchangeId } from '../../lib/types';

export const KRAKEN_METADATA = {
  id: 'kraken' as ExchangeId,
  restDocs: [
    'https://docs.kraken.com/rest/#tag/Market-Data/operation/getOrderBook',
    'https://docs.kraken.com/rest/#tag/Market-Data/operation/getOHLCData',
    'https://docs.kraken.com/rest/#tag/Market-Data/operation/getRecentTrades',
    'https://docs.kraken.com/rest/#tag/Market-Data/operation/getTradableAssetPairs',
  ],
  wsDocs: [
    'https://docs.kraken.com/api/docs/websocket-v2/',
    'https://docs.kraken.com/api/docs/websocket-v2/book',
    'https://docs.kraken.com/api/docs/websocket-v2/ticker',
    'https://docs.kraken.com/api/docs/websocket-v2/trade',
    'https://docs.kraken.com/api/docs/websocket-v2/ohlc',
  ],
  wsTopology: KRAKEN_WS_TOPOLOGY,
  wsChannels: KRAKEN_WS_CHANNELS,
  notes: [
    'Plain JSON WebSocket V2 (no compression).',
    'Server auto-sends heartbeat every second.',
    'Supports batched subscriptions.',
    'Orderbook uses incremental updates with CRC32 checksum.',
    'Timestamps are RFC3339 format - parse with Date.parse().',
    'Some symbols use X/Z prefixes (e.g., XXBTZUSD for BTC/USD).',
  ],
} as const;
